<template>
  <section class="hero">
    <div class="hero-body" v-bind:style="{ 'background-image': 'url(' + heroImage + ')' }">
      <div class="container">
        <h1 class="title">
          Product Status Dashboard
        </h1>
        <h2 class="subtitle">
          ShapeLog Initiative Tracking
        </h2>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Hero',
  props: {
    heroImage: String,
  },
};
</script>

<style scoped lang="scss">
  @import '../styles/common.scss';

  .hero {
    background-color: #CCCCCC;
    margin-bottom: 24px;

    .hero-body {
      // background-image: url('../assets/crew-22256-unsplash.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      .container {

        .title {
          color: $white;
          text-shadow: 2px 2px 4px rgba(150, 150, 150, 1);
        }

        .subtitle {
          color: $white;
          text-shadow: 2px 2px 4px rgba(150, 150, 150, 1);
        }
      }
    }
  }
</style>
